export const isNodeOverflowing = (node: HTMLElement) => {
  if (!node) {
    return false;
  }

  return node.scrollWidth > node.clientWidth;
};
